

export default {
  classificators: [],
  is_loaded: false
}